// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__E5HLi","footer":"ModalCreateQualiphyProcedure_footer__4Wrkp","additionData":"ModalCreateQualiphyProcedure_additionData__2AwjV"};